var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleScholarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 512,
    height: 512
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439,
    opacity: 0.4,
    fill: "#FF5050",
    enableBackground: "new    ",
    width: 73,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    fill: "#FF5050",
    enableBackground: "new    ",
    width: 73,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    opacity: 0.1,
    fill: "#FF5050",
    enableBackground: "new    ",
    width: 73,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 73,
    opacity: 0.1,
    fill: "#FF5050",
    enableBackground: "new    ",
    width: 512,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    opacity: 0.1,
    fill: "#FF5050",
    enableBackground: "new    ",
    width: 73,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 366,
    opacity: 0.1,
    fill: "#FF5050",
    enableBackground: "new    ",
    width: 512,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    opacity: 0.4,
    fill: "#FF5050",
    enableBackground: "new    ",
    width: 512,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    y: 439,
    opacity: 0.4,
    fill: "#FF5050",
    enableBackground: "new    ",
    width: 512,
    height: 73
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M73,0v512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M146,0v512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M219,0v512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M292,0v512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M366,0v512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M439,0v512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M512,73H0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M512,146H0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M512,219H0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M512,292H0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M512,366H0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D4D",
    strokeWidth: 0.25,
    d: "M512,439H0"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M256,350.607L99.865,223.472L256,99.865V350.607z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#356AC3",
    d: "M256,350.607l156.135-127.135L256,99.865V350.607z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A0C3FF",
    cx: 256,
    cy: 321.056,
    r: 91.078
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#76A7FA",
    d: "M173.686,282.022c14.619-30.771,45.982-52.045,82.314-52.045s67.695,21.274,82.314,52.045H173.686z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleScholarIcon);
export default __webpack_public_path__ + "static/media/GoogleScholarIcon.12910f8a32d709179aaa6938f01826fd.svg";
export { ForwardRef as ReactComponent };